export const DEFAULT_ITEMS_PER_PAGE = 20;
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const PAGE_RANGE_DISPLAYED = 5;

export type SortField =
  | "nazov"
  | "kategoriaNazov"
  | "energiaKj"
  | "proteinG"
  | "tukG"
  | "sacharidG"
  | "fpcKod";

export type SortDirection = "asc" | "desc";
